import React from 'react';
import { Typography } from '@material-ui/core';
import { ErrorMessage } from 'components/ErrorMessage';

interface Props {
  error?: Error | Error[] | string | string[];
}

export const ErrorPage: React.FC<Props> = ({ error }: Props) => {
  return (
    <>
      <Typography variant="h2">Error</Typography>
      <ErrorMessage error={error} />
    </>
  );
};
